import { HINDU_D, HINDU_FRONT_X, HINDU_FRONT_Y, HINDU_OX, HINDU_OY, HINDU_PULL } from "./hinduGeom.js";

export type HinduPose = { x: number; y: number; z: number };

export function stackY(fromBottom: number) {
  return -fromBottom * HINDU_D;
}

export function packetPose(t: number, restN: number): HinduPose {
  const landY = stackY(restN);
  const theta = Math.PI * t;
  return {
    x: 0,
    y: (landY / 2) * (1 - Math.cos(theta)),
    z: HINDU_PULL * Math.sin(theta),
  };
}

export function project(pose: HinduPose) {
  return {
    x: HINDU_OX + pose.x + pose.z * HINDU_FRONT_X,
    y: HINDU_OY + pose.y + pose.z * HINDU_FRONT_Y,
  };
}

export function restSeat(t: number) {
  if (t < 0.46) return 0;
  if (t > 0.66) return 1;
  return (t - 0.46) / 0.2;
}

export function stillInside(t: number) {
  return t < 0.4;
}
